import type { Unit } from '../types/unit';
import type { WeaponData } from '../types/weapon';

/**
 * Unit with weapons joined in place of weaponDescriptorName
 */
export type UnitWithWeapons = Omit<Unit, 'weaponDescriptorName'> & {
  weapons: WeaponData[];
};

/**
 * Weapons data structure as it appears in the API
 */
export type WeaponsData = {
  [descriptorName: string]: {
    descriptorName: string;
    hasDefensiveSmoke: boolean;
    weapons: WeaponData[];
  };
};

/**
 * Join units with their weapons, replacing weaponDescriptorName with actual weapons array
 * @param units Array of units
 * @param weaponsData Weapons data object keyed by descriptor name
 * @returns Array of units with weapons embedded
 */
export function joinUnitsWithWeapons(
  units: Unit[],
  weaponsData: WeaponsData | null
): UnitWithWeapons[] {
  return units.map((unit) => {
    const { weaponDescriptorName, ...unitWithoutWeaponDescriptor } = unit;
    
    let weapons: WeaponData[] = [];
    
    if (weaponDescriptorName && weaponsData) {
      // Remove the $/GFX/Weapon/ prefix if present, as weapons are keyed without it
      const key = weaponDescriptorName.replace(/^\$\/GFX\/Weapon\//, '');
      const weaponEntry = weaponsData[key];
      
      if (weaponEntry && weaponEntry.weapons) {
        weapons = weaponEntry.weapons;
      }
    }
    
    return {
      ...unitWithoutWeaponDescriptor,
      weapons,
    };
  });
}

